import React from 'react';
import classNameBind from 'classnames/bind';
import { TFunction } from 'react-i18next';
import {
  Stack,
  Icon,
  Text,
  withTranslation,
} from '@piwikpro/ui-components';
import styles from './FailMessage.module.css';

const bindClasses = classNameBind.bind(styles);

export interface IFailMessageProps {
  t: TFunction
  message?: string
}

export default withTranslation(['container-settings'])((
  {
    t,
    message = 'general.cardWithControls.failMessage.description',
  }: IFailMessageProps,
) => (
  <Stack
    vertical
    horizontalAlignment="middle"
    verticalAlignment="center"
    spacing="extraWide"
  >
    <Stack.Item fill />
    <Stack.Item>
      <Stack
        vertical
        horizontalAlignment="middle"
      >
        <Stack.Item>
          <Icon
            color="red"
            name="exclamation-mark-circle"
            size="medium"
          />
        </Stack.Item>
        <Stack.Item>
          <div className={bindClasses('message')}>
            <Text color="Red" dataId="TextStyle.Red">
              {t(message) as string}
            </Text>
          </div>
        </Stack.Item>
      </Stack>
    </Stack.Item>
    <Stack.Item fill />
  </Stack>
));
